import Vue from 'vue'
import Router from 'vue-router'
// 使用公共的路由拦截器
let routes = [
  {
    name: '首页',
    path: '/home',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/pages/platform/views/home/index.vue')
  },
  {
    name: '404',
    path: '/404',
    meta: {
      title: '404'
    },
    component: () =>
      import(/* webpackChunkName: "error.404" */ '@/views/error/404.vue')
  },
  {
    path: '/',
    redirect: '/home'
  }
]

Vue.use(Router)

let router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  if (!routes.some(x => x.name === to.name) && to.path !== '/') {
    console.log(to.path !== '/')
    next({
      path: '/404'
    })
  } else {
    next()
  }
})

export default router
